import { Combobox, InputBase, useCombobox } from '@mantine/core';
import { TProjectImageStorage } from '@newo/api/gateway';
import { formatDate } from '@/modules/DateTime/utils';

interface StorageSelectProps {
    storages: TProjectImageStorage[];
    value?: string;
    onChange: (storageId?: string) => void;
    label?: string;
    placeholder?: string;
    className?: string;
}

const StorageSelect = ({
    storages,
    value,
    onChange,
    label,
    placeholder = 'Select storage',
    className
}: StorageSelectProps) => {
    const combobox = useCombobox({
        onDropdownClose: () => {
            combobox.resetSelectedOption();
        }
    });

    const selected = storages.find((s) => s.id === value);

    return (
        <div className={className}>
            <Combobox
                store={combobox}
                withinPortal={false}
                onOptionSubmit={(storageId: string) => {
                    combobox.closeDropdown();
                    onChange(storageId);
                }}
            >
                <Combobox.Target>
                    <InputBase
                        pointer
                        component="button"
                        label={label}
                        rightSection={<Combobox.Chevron />}
                        rightSectionPointerEvents="none"
                        size="xs"
                        type="button"
                        onClick={() => {
                            combobox.toggleDropdown();
                        }}
                    >
                        {selected ? (
                            <div className="flex flex-col items-start whitespace-nowrap overflow-ellipsis">
                                <span>{selected.title}</span>
                            </div>
                        ) : (
                            <span>{placeholder}</span>
                        )}
                    </InputBase>
                </Combobox.Target>
                <Combobox.Dropdown>
                    <Combobox.Options className="overflow-auto" mah={250}>
                        {storages.map((storage) => (
                            <Combobox.Option
                                key={storage.id}
                                value={storage.id}
                            >
                                <div className="flex flex-col items-start">
                                    <div>{storage.title}</div>
                                    <div className="text-xs text-gray-6">
                                        Created:{' '}
                                        {formatDate(
                                            storage.created_at,
                                            'yyyy-LL-dd'
                                        )}
                                    </div>
                                </div>
                            </Combobox.Option>
                        ))}
                    </Combobox.Options>
                </Combobox.Dropdown>
            </Combobox>
        </div>
    );
};

export default StorageSelect;
